import { render, staticRenderFns } from "./StandModal.vue?vue&type=template&id=3188883f&scoped=true"
import script from "./StandModal.vue?vue&type=script&lang=js"
export * from "./StandModal.vue?vue&type=script&lang=js"
import style0 from "./StandModal.vue?vue&type=style&index=0&id=3188883f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3188883f",
  null
  
)

export default component.exports